import { SetStateAction } from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import { ReactGlobals, TreeNode } from "../Types";

const LineNode = (
  node: TreeNode,
  globals: ReactGlobals,
  load_node: (new_id: string, new_type: string) => void,
  handleTempContentChange: (event: {
    target: { value: SetStateAction<string> };
  }) => void
) => {
  return (
    <>
      <Markdown remarkPlugins={[remarkGfm, remarkBreaks]}>
        {node.ID === globals.node.ID ? globals.temporaryContent : node.Content}
      </Markdown>
    </>
  );
};

export function add_Line_to_dicts(
  constuctor_dict: Map<
    string,
    (
      node: TreeNode,
      globals: ReactGlobals,
      load_node: (new_id: string) => void,
      handleTempContentChange: (event: {
        target: { value: SetStateAction<string> };
      }) => void
    ) => JSX.Element
  >,
  type_prompt_dict: Map<string, string[]>,
  type_adding_dict: Map<string, string[]>,
  type_depth_dict: Map<string, number>
) {
  constuctor_dict.set("Line", LineNode);
  type_prompt_dict.set("Line", []);
  type_adding_dict.set("Line", []);
  type_depth_dict.set("Line", 0);
}

export default LineNode;
